const accessLevelMap = {
	0: 'BasicUserLight',
	1: 'BasicUser',
	2: 'User',
	3: 'Admin',
	4: 'CustomerAdmin',
	5: 'CompanyAdmin',
	6: 'WebSbaAdmin'
};

const accessLevelNameMap = {
	0: 'Läsbehörighet',
	1: 'Kontrollant',
	2: 'Användare',
	3: 'Admin',
	4: 'Kund-admin',
	5: 'Företags-admin',
	6: 'WebSba-admin'
};

export default ({
	methods: {
		getAccessLevel(index) {
			return accessLevelMap[index];
		},
		getAccessLevelName(index) {
			return accessLevelNameMap[index];
		}
	}
});